import { render, staticRenderFns } from "./create.page.vue?vue&type=template&id=9bdb4278&scoped=true&"
import script from "./create.page.vue?vue&type=script&lang=ts&"
export * from "./create.page.vue?vue&type=script&lang=ts&"
import style0 from "./create.page.vue?vue&type=style&index=0&id=9bdb4278&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bdb4278",
  null
  
)

export default component.exports